import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import backgroundPic from "../../assets/background.jpg";
import banner from "../../assets/shop_banner.jpg";
import { Link } from "react-router-dom";
import campersMain from "../../assets/shop/campers/campersMain.jpg";
import campers01 from "../../assets/shop/campers/campers01.jpg";
import campers02 from "../../assets/shop/campers/campers02.jpg";
import thingstodo from "../../assets/shop/thingsToDo/thingsMain.JPG";
import badge from "../../assets/shop/nail/badge.jpg";
import badge02 from "../../assets/shop/nail/badge02.jpg";
import card from "../../assets/shop/nail/card.JPG";
import catTape01 from "../../assets/shop/nail/catTape01.jpg";
import egyptTape01 from "../../assets/shop/nail/egyptTape01.jpg";
import inthecafe01 from "../../assets/shop/nail/inthecafe01.jpg";
import monster01 from "../../assets/shop/nail/monster01.jpg";

import animalTape01 from "../../assets/shop/nail/animalTape01.jpg";
import bagBiHungLu01 from "../../assets/shop/nail/bagBiHungLu01.jpg";
import birthCard01 from "../../assets/shop/nail/birthCard01.jpg";
import camperSticker01 from "../../assets/shop/nail/camperSticker01.jpg";
import stamp1_01 from "../../assets/shop/nail/stamp1_01.jpg";
import stamp2_01 from "../../assets/shop/nail/stamp2_01.jpg";
import stamp3_01 from "../../assets/shop/nail/stamp3_01.jpg";
import thankCard01 from "../../assets/shop/nail/thankCard01.jpg";


const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const products = [
    { id: 1, name: "明信片｜小怪獸", price: "$50", image: monster01 },
    // { id: 2, name: "明信片｜蜜蜂花園", price: "$40", image: thingstodo },
    // { id: 3, name: "明信片｜謝謝尼", price: "$50", image: badge },
    { id: 4, name: "明信片｜生日卡5.0", price: "$50", image: card },
    // { id: 5, name: "貼紙｜campers", price: "$120", image: egyptTape02 },
    // { id: 6, name: "貼紙｜花園轉印貼", price: "$90", image: catTape01 },
    { id: 7, name: "紙膠帶｜埃及貓貓", price: "$180", image: egyptTape01 },
    { id: 8, name: "紙膠帶｜咪咪貓貓", price: "$180", image: catTape01 },
    // { id: 9, name: "紙膠帶｜animal love", price: "$180", image: campersMain },
    { id: 10, name: "便條紙｜ThiNgs to do 褐", price: "$80", image: thingstodo },
    // { id: 11, name: "便條紙｜ThiNgs to do 藍", price: "$80", image: badge },
    { id: 12, name: "金屬徽章｜喵姆貓貓", price: "$120", image: badge02 },
    { id: 13, name: "小海報｜喫茶店", price: "$100", image: inthecafe01 },
    { id: 14, name: "餐具｜campers 露營摺疊杯", price: "", image: campers02 },
    { id: 15, name: "餐具｜campers 露營餐具組", price: "", image: campers01 },
    { id: 16, name: "餐具｜campers 露營摺疊碗", price: "", image: campersMain },
    { id: 17, name: "紙膠帶｜animal love", price: "$180", image: animalTape01 },
    { id: 18, name: "", price: "", image: bagBiHungLu01 },
    { id: 19, name: "明信片｜生日卡6.0", price: "$50", image: birthCard01 },
    { id: 20, name: "貼紙｜campers", price: "$120", image: camperSticker01 },
    { id: 21, name: "", price: "", image: stamp1_01 },
    { id: 22, name: "", price: "", image: stamp2_01 },
    { id: 23, name: "", price: "", image: stamp3_01 },
    { id: 24, name: "明信片｜謝謝尼", price: "$40", image: thankCard01 },
];

const Shop = () => {
    return (
        <Box sx={{ marginTop: "100px", padding: "20px", animation: `${fadeUp} 0.5s ease-out` }}>
            {/* Banner Section */}
            <Box
                sx={{
                    width: "100%",
                    height: "30vh",
                    minHeight: "200px",
                    maxHeight: "350px",
                    backgroundImage: `url(${banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                    marginBottom: "20px",
                }}
            />

            {/* Product Grid */}
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(3, 1fr)",
                    },
                    gap: "20px",
                    justifyContent: "center",
                }}
            >
                {products.map((product) => (
                    <Link to={`/shop-detail/${product.id}`} key={product.id} style={{ textDecoration: "none", color: "inherit" }}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            padding: "10px",
                            transition: "transform 0.3s ease-in-out",
                            "&:hover": { transform: "scale(1.05)", borderColor: "#1877F2", }
                        }}>
                            <Box
                                sx={{
                                    width: "70%",
                                    aspectRatio: "1 / 1",
                                    overflow: "hidden",
                                    borderRadius: "8px",
                                }}
                            >
                                <Box
                                    component="img"
                                    src={product.image}
                                    alt={product.name}
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                        display: "block",
                                    }}
                                />
                            </Box>
                            <Typography variant="h6" sx={{ marginTop: "10px", fontWeight: "bold", fontSize: "1rem", }}>{product.name}</Typography>
                            <Typography variant="body1" sx={{ color: "#777", fontSize: "0.8rem", }}>{product.price}</Typography>
                        </Box>
                    </Link>
                ))}
            </Box>
        </Box>
    );
};


export default Shop;
